// frontend/src/features/ui/filtersSlice.js 
// This Redux slice manages the UI’s driver filters—agency selection, search query, and global-vs-tab scope—exposing actions and selectors to update/read them.
import { createSlice } from '@reduxjs/toolkit';

const initialFilters = { agencyId: '', q: '', scope: 'tab' }; // '' = All Agencies
const initialState   = { filters: initialFilters };

const filtersSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setAgencyId: (state, action) => { state.filters.agencyId = action.payload ?? ''; },
    setQuery:    (state, action) => { state.filters.q        = action.payload ?? ''; },
    setScope:    (state, action) => {
      state.filters.scope = action.payload === 'global' ? 'global' : 'tab';
    },
    reset: (state) => { state.filters = initialFilters; },
  },
});

export const { setAgencyId, setQuery, setScope, reset } = filtersSlice.actions;

// Selectors (always read from state.ui.filters)
export const selectFilters  = (s) => s.ui?.filters ?? initialFilters;
export const selectAgencyId = (s) => s.ui?.filters?.agencyId ?? '';
export const selectQuery    = (s) => s.ui?.filters?.q ?? '';
export const selectScope    = (s) => s.ui?.filters?.scope ?? 'tab';

export default filtersSlice.reducer;
